module.exports = __webpack_public_path__ + "assets/settings.e25523e7.svg";